import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoImage from "./images/events/logo_one.png";

function Nav({ isDarkMode }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPortfolioOpen, setIsPortfolioOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setIsPortfolioOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const togglePortfolio = () => {
    setIsPortfolioOpen((prev) => !prev);
  };

  return (
    <>
      <nav className={`nav ${isDarkMode ? "dark" : ""}`}>
        <div className="nav-container">
          <Link to="/" className="logo-link" onClick={closeAllMenus}>
            <img
              src={logoImage}
              alt="West LA Portraits"
              className="logo-image"
            />
          </Link>

          <button
            className={`menu-toggle ${isMenuOpen ? "is-open" : ""}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMenuOpen}
            aria-controls="fullscreen-menu"
            type="button"
          >
            <span />
            <span />
          </button>
        </div>
      </nav>

      <div
        id="fullscreen-menu"
        className={`nav-overlay ${isMenuOpen ? "active" : ""} ${isDarkMode ? "dark" : ""}`}
      >
        <div className="nav-overlay__inner">
          <ul className="nav-overlay__list">
            <li className="nav-overlay__item">
              <Link to="/" onClick={closeAllMenus} className="nav-overlay__link">
                Home
              </Link>
            </li>

            <li className={`nav-overlay__item nav-overlay__item--group ${isPortfolioOpen ? "open" : ""}`}>
              <button
                type="button"
                className="nav-overlay__trigger"
                onClick={togglePortfolio}
                aria-expanded={isPortfolioOpen}
                aria-controls="overlay-portfolio-submenu"
              >
                <span>Services</span>
                <span className="nav-overlay__symbol" aria-hidden="true">
                  {isPortfolioOpen ? "−" : "+"}
                </span>
              </button>

              <ul
                id="overlay-portfolio-submenu"
                className={`nav-overlay__submenu ${isPortfolioOpen ? "active" : ""}`}
              >
                <li>
                  <Link to="/projects/headshots" onClick={closeAllMenus}>
                    Commercial Headshots
                  </Link>
                </li>
                <li>
                  <Link to="/projects/portraits" onClick={closeAllMenus}>
                     Family Portraits
                  </Link>
                </li>
                <li>
                  <Link to="/projects/products" onClick={closeAllMenus}>
                    Product
                  </Link>
                </li>
                <li>
                  <Link to="/projects/weddings" onClick={closeAllMenus}>
                    Weddings
                  </Link>
                </li>
                <li>
                  <Link to="/projects/graduations" onClick={closeAllMenus}>
                    Graduations
                  </Link>
                </li>
              
              </ul>
            </li>

            <li className="nav-overlay__item">
              <Link to="/about" onClick={closeAllMenus} className="nav-overlay__link">
                About
              </Link>
            </li>

            <li className="nav-overlay__item">
              <Link to="/booking" onClick={closeAllMenus} className="nav-overlay__link nav-overlay__link--accent">
                Book Me
              </Link>
            </li>
          </ul>

          <div className="nav-overlay__footer">
            <p>West LA Portraits</p>
            <p>Portraits · Headshots · Graduations · Weddings · Families · Products </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Nav;